import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Dropdown } from 'antd';
import { DownOutlined, AppstoreOutlined } from '@ant-design/icons';

const LandingHeader = () => {
    const navigate = useNavigate();

    const toolItems = [
        {
            key: '0',
            label: (
                <div onClick={() => navigate('/cong-cu')} className="flex items-center py-1 cursor-pointer font-bold text-primary border-b border-slate-100 pb-2 mb-1">
                    Xem tất cả công cụ miễn phí &rarr;
                </div>
            ),
        },
        {
            key: '1',
            label: (
                <div onClick={() => navigate('/cong-cu/tra-cuu-vtf')} className="flex items-center gap-2 py-1 cursor-pointer group">
                    <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-indigo-500/10 text-indigo-500 group-hover:bg-indigo-500 group-hover:text-white transition-all">
                        <span className="material-symbols-outlined text-lg">person_search</span>
                    </div>
                    <span className="font-bold text-slate-700 group-hover:text-indigo-500 transition-colors">Tra cứu mã VTF</span>
                </div>
            ),
        },
        {
            key: '3',
            label: (
                <div onClick={() => navigate('/cong-cu/tao-ma-qr')} className="flex items-center gap-2 py-1 cursor-pointer group">
                    <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-primary/10 text-primary group-hover:bg-primary group-hover:text-white transition-all">
                        <span className="material-symbols-outlined text-lg">qr_code_scanner</span>
                    </div>
                    <span className="font-bold text-slate-700 group-hover:text-primary transition-colors">Tạo mã QR vĩnh viễn</span>
                </div>
            ),
        },
        {
            key: '4',
            label: (
                <div onClick={() => navigate('/cong-cu/vong-quay-may-man')} className="flex items-center gap-2 py-1 cursor-pointer group">
                    <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-rose-500/10 text-rose-500 group-hover:bg-rose-500 group-hover:text-white transition-all">
                        <span className="material-symbols-outlined text-lg">pie_chart</span>
                    </div>
                    <span className="font-bold text-slate-700 group-hover:text-rose-500 transition-colors">Vòng quay may mắn</span>
                </div>
            ),
        },
        {
            key: '5',
            label: (
                <div onClick={() => navigate('/cong-cu/tra-cuu-ket-qua-thi')} className="flex items-center gap-2 py-1 cursor-pointer group">
                    <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-indigo-500/10 text-indigo-500 group-hover:bg-indigo-500 group-hover:text-white transition-all">
                        <span className="material-symbols-outlined text-lg">verified</span>
                    </div>
                    <span className="font-bold text-slate-700 group-hover:text-indigo-500 transition-colors">Tra cứu kết quả thi</span>
                </div>
            ),
        },
    ];

    const parentItem = {
        key: 'parent',
        label: (
            <div onClick={() => navigate('/tra-cuu-phu-huynh')} className="flex items-center gap-2 py-1 cursor-pointer group">
                <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-accent/10 text-accent group-hover:bg-accent group-hover:text-white transition-all">
                    <span className="material-symbols-outlined text-lg">family_restroom</span>
                </div>
                <span className="font-bold text-slate-700 group-hover:text-accent transition-colors">Cổng phụ huynh</span>
            </div>
        ),
    };

    return (
        <header className="fixed top-4 left-0 right-0 px-4 sm:px-6 z-50 transition-all duration-300">
            <div className="mx-auto max-w-5xl rounded-full border border-slate-200/50 bg-white/70 backdrop-blur-xl shadow-sm px-4 sm:px-6 py-3 flex items-center justify-between dark:bg-slate-900/70 dark:border-slate-800">
                <div className="flex items-center gap-2 cursor-pointer" onClick={() => { navigate('/'); window.scrollTo(0, 0); }}>
                    <img alt="1ms Logo" className="h-10 w-auto" src="/logo.png" />
                </div>
                <nav className="hidden md:flex flex-1 justify-center items-center gap-10 text-slate-600 dark:text-slate-300">
                    <a className="text-sm font-bold hover:text-accent transition-colors relative group" href="/#features">
                        Tính năng
                        <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-accent transition-all group-hover:w-full"></span>
                    </a>
                    <a className="text-sm font-bold hover:text-accent transition-colors relative group" href="/#testimonials">
                        HLV tin dùng
                        <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-accent transition-all group-hover:w-full"></span>
                    </a>
                    <a
                        className="text-sm font-bold hover:text-accent transition-colors relative group"
                        href="/tra-cuu-phu-huynh"
                        onClick={(e) => { e.preventDefault(); navigate('/tra-cuu-phu-huynh'); }}
                    >
                        Phụ huynh
                        <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-accent transition-all group-hover:w-full"></span>
                    </a>
                    <a className="text-sm font-bold hover:text-accent transition-colors relative group" href="/#faq">
                        Hỏi đáp
                        <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-accent transition-all group-hover:w-full"></span>
                    </a>

                    <Dropdown menu={{ items: toolItems }} trigger={['hover']} placement="bottom">
                        <a
                            href="/cong-cu"
                            onClick={(e) => { e.preventDefault(); navigate('/cong-cu'); }}
                            className="text-sm font-bold hover:text-accent transition-colors relative group cursor-pointer flex items-center gap-1.5"
                        >
                            <AppstoreOutlined className="text-lg" />
                            Miễn phí <DownOutlined className="text-[10px]" />
                            <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-accent transition-all group-hover:w-full"></span>
                        </a>
                    </Dropdown>
                </nav>
                <div className="flex items-center gap-3">
                    {/* Mobile Tools Menu */}
                    {/* Mobile: thêm lối vào cổng phụ huynh ở cuối menu (desktop nằm trên thanh menu) */}
                    <Dropdown menu={{ items: [...toolItems, { type: 'divider' }, parentItem] }} trigger={['click']} placement="bottomRight">
                        <button className="md:hidden flex items-center gap-1 text-sm font-bold text-slate-600 hover:text-primary transition-colors cursor-pointer bg-slate-50 border border-slate-200 px-3 py-1.5 rounded-full shadow-sm">
                            Miễn phí <DownOutlined className="text-[10px]" />
                        </button>
                    </Dropdown>

                    <button onClick={() => navigate('/login')} className="rounded-full bg-primary px-5 sm:px-6 py-2 sm:py-2.5 text-sm font-bold text-white shadow-lg shadow-primary/30 hover:bg-primary/90 hover:-translate-y-0.5 transition-all">Đăng nhập</button>
                </div>
            </div>
        </header>
    );
};

export default LandingHeader;
